export default __webpack_public_path__ + "static/media/jeebly.dc6ff782.svg";